import { render } from "./EmergencyAttachmentForm.vue?vue&type=template&id=4e1a2d04&scoped=true&ts=true"
import script from "./EmergencyAttachmentForm.ts?vue&type=script&lang=ts"
export * from "./EmergencyAttachmentForm.ts?vue&type=script&lang=ts"

import "./EmergencyAttachmentForm.scss?vue&type=style&index=0&id=4e1a2d04&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e1a2d04"]])

export default __exports__